// Scroll parallax (like twicemediahouse.com/about): each floating collage photo drifts up linearly while it
// passes through the viewport, up to 25% of its own height. Drift is measured from where the photo sits
// with the page scrolled to the top, so the designed layout is exactly what shows on load. Loaded on the Who we are page (page.about). Replaces the theme's per-image parallax there.
(() => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const DISTANCE = 25; // percent of the photo's own height

  // Move the inner frame so the theme's own positioning transform on the block stays untouched
  // The hero photos use the theme's own parallax (same as the Careers page), so skip the first section
  const hero = document.querySelector('main .shopify-section');
  const items = [...document.querySelectorAll('main .content-block--image .image-block__inner')]
    // The "Rival around the world" globe sits behind its title and must stay centred on it, so it doesn't drift
    .filter((inner) => inner.querySelector('img') && !hero?.contains(inner) && !inner.closest('[id$="__rich_text_p6why7"]'))
    .map((inner) => {
      inner.classList.add('image-parallax');
      return { inner, block: inner.parentElement, distance: DISTANCE };
    });

  if (!items.length) return;

  const clamp = (value) => Math.min(1, Math.max(0, value));
  const progressAt = (top, height, viewport) => clamp((viewport - top) / (viewport + height));

  const update = () => {
    const viewport = window.innerHeight;
    // read all positions first, then write, to avoid layout thrashing
    const offsets = items.map(({ block, distance }) => {
      const rect = block.getBoundingClientRect();
      const start = progressAt(rect.top + window.scrollY, rect.height, viewport); // page scrolled to top
      return -distance * (progressAt(rect.top, rect.height, viewport) - start);
    });
    items.forEach(({ inner }, index) => {
      inner.style.transform = `translate3d(0, ${offsets[index].toFixed(2)}%, 0)`;
    });
  };

  let queued = false;
  const onScroll = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      update();
    });
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  window.addEventListener('load', update);
  update();
})();
